
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getBankInfoList } from '@/api/ccx'

@Component
export default class bankPopup extends Vue {
  @Prop({ default: '' }) title?: string

  popShow = false
  columns = []

  created() {
    this.getBankInfoListFunc()
  }

  showPop() {
    this.popShow = true
  }

  getBankInfoListFunc() {
    getBankInfoList({ bankName: '' }).then((res) => {
      this.columns = res.data.records
    })
  }

  onCancel() {
    this.popShow = false
  }

  onConfirm(val: any) {
    this.popShow = false
    this.$emit('confirm', val)
  }
}
